/**
 * Chrome shared by the onboarding screens. Class strings rather than a stylesheet, so a
 * screen composes them with its own Tailwind instead of reaching for a CSS module.
 */
export const ONBOARDING_SCREEN = {
  page: 'relative flex w-full flex-col',
  /** pb clears the fixed footer, so scrolled content never sits behind it. Below `sm` the
   * footer is in the flow and needs no clearing, only separating. */
  content:
    'flex w-full flex-col items-center gap-6 px-6 pt-2 pb-30 max-sm:px-4 max-sm:pb-6',
  /**
   * Fades in on save and back out, so it starts invisible and out of the hit-testing path.
   * Anchored to the viewport, because a long card means the member is scrolled when the
   * save lands and a page-anchored badge animates far above what they are looking at. The
   * caller insets it past Haven's desktop panel, which is an in-flow sibling holding real
   * width rather than an overlay.
   */
  autosaveIndicator:
    'pointer-events-none fixed top-6 z-10 flex items-center gap-1.5 rounded-lg border border-neutral-200 bg-neutral-0 px-3 py-1.5 opacity-0 shadow-sm max-sm:top-2',
  iconWrapper: 'flex h-20 w-20 shrink-0 items-center justify-center',
  iconImage: 'h-20 w-20 object-contain',
  header: 'flex flex-col items-center justify-center gap-1 text-center',
  surfaceCard:
    'flex w-full flex-col items-start rounded-3xl border border-neutral-200 bg-neutral-0 p-6 shadow-surface-card',
  /**
   * OnboardingStickyNav owns position, padding, borders and mobile stacking. This only
   * re-applies Layout's own content cap so the buttons line up with the content column.
   */
  footer: 'mx-auto max-w-[1200px]',
  /** The column the content sits in: progress bars, question cards, account lists. */
  contentColumn: 'max-w-150',
  /** The narrower column the summary surfaces use. */
  narrowColumn: 'max-w-[450px]',
} as const
